/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [share-post-button.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 10.02.20, 17:16
 */
import React, {useEffect, useState} from 'react';

import {RoundedButton} from "../../navigation/buttons/nav-buttons";
import {PENDING_STATUS} from "../../../actions";
import {ImageLink} from "../../navigation/links/nav-headlines";
import {useLanguage} from "../../configuration/configuration";
import {NavigationGroup, NavigationRow} from "../../navigation/layout/nav-layout";
import {useAuthorization} from "../../../selectors";
import DialogBox from "../dialog-box";
import SmoothScrollbar from "../../scrollbars/smooth-scrollbar";
import {SendRounded, Share} from "@material-ui/icons";
import useFetchSpaces from "../../hooks/use-fetch-spaces";
import {SpinnerBig} from "../../util/spinner";
import useAsyncSharePost from "../../hooks/async-share-post";


const SharePostDialog = ({postId, setOpen}) => {
    const [showInput, setShowInput] = useState({show: false, id: null});
    const [comment, setComment] = useState(null);
    const {fetchShareablePeekSpaces, spaces, status} = useFetchSpaces();
    const {principalUsername, principal} = useAuthorization();
    const {sharePost} = useAsyncSharePost();
    const Lang = useLanguage();

    useEffect(() => {
        fetchShareablePeekSpaces();
    }, []);

    const handleSharePost = (spaceId, postId, spaceName) => event => {
        event.preventDefault();
        sharePost(principalUsername, spaceId, postId, spaceName, comment, setOpen);
    }

    const handleShowInput = id => {
        setShowInput({show: showInput.id === id ? !showInput.show : true, id: id});
    }

    const renderSingleEntry = (space, postId) => {
        return <div key={space.id}>
            <NavigationRow key={space.id} className='mt-2'>
                <NavigationGroup>
                    <ImageLink to={`/${space.username}/space/${space.id}`}
                               image={space.url}
                               text={space.name}/>
                </NavigationGroup>

                <NavigationGroup className='mr-3'>
                    <RoundedButton className='btn-outline-light'
                                   onClick={() => handleShowInput(space.id)}>
                        <Share aria-hidden="true"/>
                    </RoundedButton>
                </NavigationGroup>
            </NavigationRow>

            {showInput.show && showInput.id === space.id && <div className='my-2'>
                <div className='box-aligned'>
                        <textarea className='form-control'
                                  placeholder={Lang.post.shared.placeholder} id='shareCommentId'
                                  onChange={handleOnCommentChange}/>
                    <RoundedButton className='btn-primary ml-2 mr-3'
                                   title={Lang.dialog.sharePost.shareWith(space.name)}
                                   onClick={handleSharePost(space.id, postId, space.name)}>
                        <SendRounded className='clr-white pl-1'/>
                    </RoundedButton>
                </div>
            </div>}
        </div>
    }

    const renderShareEntries = (spaces, postId) => {
        return spaces.map(space => {
            return renderSingleEntry(space, postId);
        })
    }

    const handleOnCommentChange = (event) => {
        event.preventDefault();
        setComment(event.target.value);
    }

    return <div className='share-post-dialog'>
        <DialogBox title={Lang.dialog.sharePost.title}
                   isOpen={true}
                   setIsOpen={() => setOpen(false)}>
            <div className='my-2'>
                {Lang.dialog.sharePost.subtitle}
            </div>

            {status === PENDING_STATUS ? <SpinnerBig/>
                : <SmoothScrollbar enableOverScroll={true} className='share-post-content mr-1 mb-3'>
                    {renderShareEntries(spaces, postId)}
                </SmoothScrollbar>}

        </DialogBox>

    </div>
}

export default SharePostDialog;
